import { render, staticRenderFns } from "./OriginPage.vue?vue&type=template&id=0445357b&"
import script from "./OriginPage.vue?vue&type=script&lang=js&"
export * from "./OriginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports